import { render } from "./eosrc-card-new.vue?vue&type=template&id=3b2b58db"
import script from "./eosrc-card-new.vue?vue&type=script&setup=true&lang=js"
export * from "./eosrc-card-new.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/e-grid/eosrc-card/eosrc-card-new.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b2b58db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b2b58db', __exports__)) {
    api.reload('3b2b58db', __exports__)
  }
  
  module.hot.accept("./eosrc-card-new.vue?vue&type=template&id=3b2b58db", () => {
    api.rerender('3b2b58db', render)
  })

}


export default __exports__